import {
  FETCH_DATA_START,
  FETCH_DATA_SUCCESS,
  FETCH_SPECIFIC_SURVEY_DATA_SUCCESS,
  FETCH_OWNED_AGENCY_DATA_SUCCESS,
  FETCH_OWNED_AGENCY_DATA_START,
  REMOVE_OWNED_AGENCY_DATA,
  FETCH_DATA_FAIL,
} from './actionTypes';
import axios from '../../API/axiosConfig';
import { makeURL } from '../../helperFunctions';

export const fetchData = agencyId => {
  return async dispatch => {
    dispatch({
      type: FETCH_DATA_START,
    });

    try {
      const url = '/fs/data';
      const {
        data: { result: allData },
      } = await axios.get(url);

      dispatch({
        type: FETCH_DATA_SUCCESS,
        agencyId,
        ...allData,
      });
      return {
        err: false,
        result: allData,
      };
    } catch (err) {
      dispatch({
        type: FETCH_DATA_FAIL,
      });
      return {
        err: true,
        result: err.message,
      };
    }
  };
};

export const fetchSpecificSurveyData = (surveyType, agenciesToFetch) => {
  return async dispatch => {
    dispatch({
      type: FETCH_DATA_START,
    });

    try {
      const url = '/fs/specific-survey-data';
      const payload = {
        surveyType,
        agenciesToFetch,
      };
      const {
        data: { result: surveyData },
      } = await axios.post(url, payload);

      dispatch({
        type: FETCH_SPECIFIC_SURVEY_DATA_SUCCESS,
        surveyType,
        surveyData,
      });
      return {
        err: false,
        result: surveyData,
      };
    } catch (err) {
      dispatch({
        type: FETCH_DATA_FAIL,
      });
      return {
        err: true,
        result: err.message,
      };
    }
  };
};

export const fetchOwnedAgencyData = agencyId => {
  return async dispatch => {
    dispatch({
      type: FETCH_OWNED_AGENCY_DATA_START,
    });

    try {
      const url = '/fs/owned-agency-data';
      const payload = {
        agencyId,
      };
      const {
        data: { result: ownedAgencyData },
      } = await axios.post(url, payload);

      dispatch({
        type: FETCH_OWNED_AGENCY_DATA_SUCCESS,
        agencyId,
        ownedAgencyData,
      });
      return {
        err: false,
        result: ownedAgencyData,
      };
    } catch (err) {
      dispatch({
        type: FETCH_DATA_FAIL,
      });
      return {
        err: true,
        result: err.message,
      };
    }
  };
};

export const fetchOwnedAgencyDataBySurveyId = (surveyId, surveyType) => {
  return async dispatch => {
    dispatch({
      type: FETCH_OWNED_AGENCY_DATA_START,
    });

    try {
      const url = '/fs/owned-agency-data-by-survey-id';
      const payload = {
        surveyId,
        surveyType,
      };

      const { data } = await axios.post(url, payload);

      if (!data?.result?.data || !data?.result?.matchingAgencyId) {
        // Company tried to access survey that they do not own
        window.location.pathname = makeURL('/home');
        return;
      }

      dispatch({
        type: FETCH_OWNED_AGENCY_DATA_SUCCESS,
        agencyId: data.result.matchingAgencyId,
        ownedAgencyData: data.result.data,
      });
      return {
        err: false,
        result: data.result.data,
      };
    } catch (err) {
      dispatch({
        type: FETCH_DATA_FAIL,
      });
      return {
        err: true,
        result: err.message,
      };
    }
  };
};

export const removeOwnedAgencyData = agencyId => {
  return async dispatch => {
    dispatch({
      type: FETCH_OWNED_AGENCY_DATA_START,
    });

    await new Promise((resolve, reject) => setTimeout(() => resolve('fake timeout'), 1000));
    dispatch({
      type: REMOVE_OWNED_AGENCY_DATA,
      agencyId,
    });
  };
};
